import { AxiosInstance } from 'axios';
import baseAxios from '@/helpers/forms/axios';
import { orderItemInterface } from '../orderItems';
import { packageInterface } from '../packages';

export interface packageItemInterface {
    id: number
    createdAt: string
    updatedAt: string
    orderItemId: number
    orderItem?: orderItemInterface
    packageId: number
    package?: packageInterface
    quantity: number
    toteBarcode: string
    packedAt: string
    packedByUserId: number
    lotCode: string
}

export default (axios: AxiosInstance = baseAxios): { deleteOrderPackageItem: (packageItemId: number) => Promise<void>; } => ({
    deleteOrderPackageItem: async (packageItemId: number): Promise<void> => {
        await axios.delete<void>(`/api/package-items/${packageItemId}`);
    },
});
